/**
 * Get comprehensive device and browser information
 */
export function getDeviceInfo() {
	const deviceInfo = {
		userAgent: navigator.userAgent,
		platform: navigator.platform,
		language: navigator.language,

		screenResolution: `${window.screen.width}x${window.screen.height}`,
		viewportSize: `${window.innerWidth}x${window.innerHeight}`,
		colorDepth: window.screen.colorDepth,
		pixelRatio: window.devicePixelRatio || 1,

		deviceMemory: navigator.deviceMemory || 'unknown',
		hardwareConcurrency: navigator.hardwareConcurrency || 'unknown',

		connectionType: 'unknown',
		connectionDownlink: 'unknown',

		cookieEnabled: navigator.cookieEnabled,
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

		collectedAt: new Date().toISOString(),
	};

	if (navigator.connection) {
		deviceInfo.connectionType = navigator.connection.effectiveType || 'unknown';
		deviceInfo.connectionDownlink = navigator.connection.downlink || 'unknown';
	}

	return deviceInfo;
}

/**
 * Get user information from user object
 */
export function getUserInfo(user) {
	return {
		userId: user._id,
		username: user.username,
		email: user.email || '',
		loginTimestamp: new Date().toISOString(),
	};
}
